import React from "react";
import { ReactComponent as BagIcon } from "@preownedfront/lib-reowds/icons/24/bag.svg";
import { stateConnect } from "src/hooks/state/use-app-state";
import { Link } from "react-router-dom";
import { ROUTE_PATHS } from "src/utils/constants";
import { t } from "i18next";

const CartCounterLink = (props: { itemCount: number, className?: string }) => {
  const { itemCount, className = '' } = props;
  const ariaLabel = itemCount === 0
    ? t("cart-title-empty")
    : t("bag-icon-number", { count: itemCount });

  return (
    <Link className={`nav__icons__wm-icon ${className}`} to={ROUTE_PATHS.CART} aria-label={ariaLabel}>
      <div className="bag-icon-container">
        <BagIcon className="nav__icons__wm-icon__svg bag-icon" />
        <span className="bag-icon-number" aria-hidden="true">{itemCount}</span>
      </div>
    </Link>
  );
}


export default stateConnect(CartCounterLink, state => ({ itemCount: state?.cart?.content?.itemCount ?? 0 }));
